<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#FDCE48"
      spinner="bar-fade-scale"
    />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showSnackBar" color="#FDCE48" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">
          <span style="color: #000">
            {{ msg }}
          </span>
        </v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: #000">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap justify-center>
      <v-flex xs12 text-left>
        <span class="itemHeading"> Hives </span>
      </v-flex>
    </v-layout>
    <v-layout wrap justify-end pt-4>
      <v-flex xs12 sm4 md3 xl2 text-left pr-md-1>
        <v-autocomplete
          outlined
          dense
          clearable
          color="#000000"
          label="Search by Username"
          v-model="userid"
          :items="users"
          item-color="#000000"
          item-text="username"
          item-value="_id"
          hide-details
        >
          <template v-slot:selection="{ item }">
            {{ item.username }}
          </template>
          <template v-slot:item="{ item }">
            <span class="text-left">
              {{ item.username }}
            </span>
          </template>
        </v-autocomplete>
      </v-flex>
      <v-flex xs12 sm4 md2 xl2 text-left pt-2 pt-sm-0 px-md-1>
        <v-autocomplete
          outlined
          dense
          clearable
          color="#000000"
          label="Apiary"
          v-model="apiary"
          :items="apiaries"
          item-color="#000000"
          item-text="apiaryid"
          item-value="_id"
          hide-details
        >
          <template v-slot:item="{ item }">
            <span class="text-left">
              {{ item.apiaryid }} ({{ item.user.username }})
            </span>
          </template>
          <template v-slot:selection="{ item }">
            <span class="text-left">
              {{ item.apiaryid }} ({{ item.user.username }})
            </span>
          </template>
        </v-autocomplete>
      </v-flex>
      <v-flex xs12 sm4 md2 xl2 text-left pt-2 pt-sm-0 px-md-1>
        <v-autocomplete
          outlined
          dense
          clearable
          color="#000000"
          label="Status"
          v-model="status"
          :items="statuses"
          item-color="#000000"
          hide-details
        >
          <template v-slot:item="{ item }">
            <span class="text-left">
              {{ item }}
            </span>
          </template>
        </v-autocomplete>
      </v-flex>
      <v-flex xs12 sm4 md2 xl2 text-left pt-2 pt-sm-0 px-md-1>
        <v-menu
          ref="fromDatePicker"
          v-model="fromDatePicker"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              outlined
              dense
              clearable
              v-model="fromDate"
              label="From Date"
              v-bind="attrs"
              v-on="on"
              hide-details
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="fromDate"
            no-title
            @input="fromDatePicker = false"
          ></v-date-picker>
        </v-menu>
      </v-flex>
      <v-flex xs12 sm4 md2 xl2 text-left pt-2 pt-sm-0 pl-md-1>
        <v-menu
          ref="toDatePicker"
          v-model="toDatePicker"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              outlined
              dense
              clearable
              v-model="toDate"
              label="To Date"
              v-bind="attrs"
              v-on="on"
              hide-details
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="toDate"
            no-title
            @input="toDatePicker = false"
          ></v-date-picker>
        </v-menu>
      </v-flex>
    </v-layout>
    <v-layout wrap justify-start py-4>
      <v-flex xs12 lg12 xl6 pa-1 v-for="(item, i) in hives" :key="i">
        <HivesItem v-bind:storage="item" @stepper="winStepper" />
      </v-flex>
      <v-flex xs12 v-if="hives.length < 1">
        <span class="itemKey"> No data available </span>
      </v-flex>
    </v-layout>
    <v-layout wrap justify-center v-if="pages > 1">
      <v-flex xs12>
        <v-pagination
          v-model="currentPage"
          :length="pages"
          :total-visible="7"
          color="#919191"
        ></v-pagination>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
import HivesItem from "./hivesItem";
export default {
  components: {
    HivesItem,
  },
  data() {
    return {
      appLoading: false,
      ServerError: false,
      showSnackBar: false,
      timeout: 5000,
      msg: null,
      hives: [],
      users: [],
      apiaries: [],
      statuses: ["Active", "Reset"],
      pages: 0,
      count: 20,

      fromDate: this.$route.query.from,
      toDate: this.$route.query.to,
      fromDatePicker: false,
      toDatePicker: false,

      apiary: this.$route.query.apiary,
      status: this.$route.query.status,
      currentPage: this.$route.query.page ? Number(this.$route.query.page) : 1,
      userid: this.$route.query.user,
    };
  },
  watch: {
    currentPage() {
      this.$router.push({
        path: "/Admin/Hives",
        query: {
          page: this.currentPage,
          user: this.user,
          status: this.status,
          apiary: this.apiary,
          from: this.fromDate,
          to: this.toDate,
        },
      });
    },
    userid() {
      this.changePage();
    },
    status() {
      this.changePage();
    },
    apiary() {
      this.changePage();
    },
    fromDate() {
      this.changePage();
    },
    toDate() {
      this.changePage();
    },
  },
  beforeMount() {
    this.getData();
    this.getApiaries();
    this.getUsers();
  },
  methods: {
    changePage() {
      this.$router.push({
        path: "/Admin/Hives",
        query: {
          user: this.userid,
          status: this.status,
          apiary: this.apiary,
          from: this.fromDate,
          to: this.toDate,
        },
      });
    },
    getApiaries() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/cluster/admingetlist",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          page: 0,
          count: 0,
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.apiaries = response.data.data;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/colony/admingetList",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          cluster: this.apiary,
          userid: this.userid,
          status: this.status,
          createdfrom: this.fromDate,
          createdto: this.toDate,
          page: this.page,
          count: this.count,
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.hives = response.data.data;
            this.pages = response.data.pages;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    getUsers() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/user/allUsers",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          role: "User",
          page: 0,
          count: 0,
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status == true) {
            this.users = response.data.data;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    winStepper(windowData) {
      if (windowData.pageResponse.status) {
        this.msg = "Hive Deleted Successfully";
        this.showSnackBar = true;
        if (windowData.getData) this.getData();
      } else {
        this.msg = "Hive not Deleted";
        this.showSnackBar = true;
      }
    },
  },
};
</script>